import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { getAPIURL } from '../host';
import MusicSheet, { MusicSheetAsJSON } from '../models/MusicSheet';

export const toMusicSheet = (musicSheetAsJSON: MusicSheetAsJSON) =>
  new MusicSheet(
    musicSheetAsJSON.id,
    musicSheetAsJSON.fileContents,
    musicSheetAsJSON.numberOfMeasures,
    musicSheetAsJSON.lastOffset,
    musicSheetAsJSON.title,
    musicSheetAsJSON.composer,
    musicSheetAsJSON.category
  );

/** The catalogue of sheets; `reload` fetches it again, e.g. after a sheet was imported. */
const useMusicSheets = (): [MusicSheet[], () => Promise<void>] => {
  const [musicSheets, setMusicSheets] = useState<MusicSheet[]>([]);

  const reload = useCallback(async () => {
    const response = await axios.get<MusicSheetAsJSON[]>(`${getAPIURL()}/music-sheets`);
    setMusicSheets(response.data.map(toMusicSheet));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return [musicSheets, reload];
};

export default useMusicSheets;
